export const SITE_URL = "https://www.moustiquebordeaux.fr";

export const COMPANY = {
  brand: "Moustique Bordeaux",
  legalName: "Termite Habitat 33",
  phone: "07 45 71 15 10",
  phoneHref: "tel:+33745711510",
  phoneIntl: "+33745711510",
  email: "termitehabitat33@gmail.com",
  street: "53 avenue de la forêt d'Arboudeau",
  postalCode: "33290",
  city: "Parempuyre",
  siren: "837 746 700",
  manager: "Marc BARBIER",
  facebook: "https://www.facebook.com/profile.php?id=61570838585826",
};

export const ZONES = [
  { slug: "gironde", name: "Gironde", path: "/traitement-moustique-gironde", image: "/images/gironde-campagne.webp", tag: "Tout le département 33" },
  { slug: "bordeaux", name: "Bordeaux", path: "/traitement-moustique-bordeaux", image: "/images/bordeaux-miroir.webp", tag: "Bordeaux Métropole" },
  { slug: "libourne", name: "Libourne", path: "/traitement-moustique-libourne", image: "/images/libourne-vignes.webp", tag: "Libournais & Saint-Émilion" },
  { slug: "bassin-arcachon", name: "Bassin d'Arcachon", path: "/traitement-moustique-bassin-arcachon", image: "/images/arcachon-dune.webp", tag: "Arcachon, Cap Ferret, La Teste" },
  { slug: "medoc", name: "Médoc", path: "/traitement-moustique-medoc", image: "/images/medoc-chateau.webp", tag: "Médoc & estuaire" },
];

export const SPECIES = [
  { slug: "moustique-tigre", name: "Moustique tigre", path: "/moustique-tigre-gironde", tag: "Aedes albopictus · actif le jour", image: "/images/moustique-tigre.webp" },
  { slug: "moustique-commun", name: "Moustique commun", path: "/moustique-commun-gironde", tag: "Culex pipiens · actif la nuit", image: "/images/moustique-feuille.webp" },
  { slug: "moustique-marais", name: "Moustique des marais", path: "/moustique-des-marais-gironde", tag: "Bassin, Médoc, estuaire", image: "/images/arcachon-dune.webp" },
  { slug: "moustique-bois", name: "Moustique des bois", path: "/moustique-des-bois-gironde", tag: "Forêts et jardins arborés", image: "/images/gironde-campagne.webp" },
];

export const CONSEILS_LIST = [
  { slug: "printemps", name: "Printemps", path: "/conseils/moustique-tigre-printemps", tag: "Mars · Avril · Mai", image: "/images/famille-jardin.webp" },
  { slug: "ete", name: "Été", path: "/conseils/moustique-tigre-ete", tag: "Juin · Juillet · Août", image: "/images/jardin-soir.webp" },
  { slug: "automne", name: "Automne", path: "/conseils/moustique-tigre-automne", tag: "Sept. · Oct. · Nov.", image: "/images/libourne-vignes.webp" },
  { slug: "hiver", name: "Hiver", path: "/conseils/moustique-tigre-hiver", tag: "Déc. · Janv. · Fév.", image: "/images/medoc-chateau.webp" },
];

export const TERMITE_LINKS = [
  { label: "Traitement termite Gironde", href: "https://termitehabitat33.fr/traitement-des-termites-en-gironde" },
  { label: "Traitement termite Bordeaux", href: "https://termitehabitat33.fr/traitement-des-termites-a-bordeaux" },
  { label: "Traitement termite Bassin d'Arcachon", href: "https://termitehabitat33.fr/traitement-des-termites-sur-le-bassin-darcachon" },
  { label: "Spécialiste termites à Bordeaux", href: "https://termitebordeaux.fr/" },
  { label: "Méthodes de traitement anti-termite", href: "https://termitehabitat33.fr/methodes-de-traitement" },
  { label: "Prévention des termites en Gironde", href: "https://termitehabitat33.fr/prevention-des-termites" },
  { label: "Les termites en Gironde", href: "https://termitehabitat33.fr/termites" },
];

export const NAV = [
  { label: "Moustiques", path: "/moustiques", children: SPECIES },
  { label: "Traitements", path: "/traitements" },
  { label: "Méthodes", path: "/methodes" },
  { label: "Solutions", path: "/solutions" },
  { label: "Secteurs", path: "/secteurs", children: ZONES },
  { label: "Conseils", path: "/conseils-anti-moustique-tigre", children: CONSEILS_LIST },
  { label: "À propos", path: "/a-propos" },
];

export const PROMISES = [
  "Recherche et élimination des sources de larves",
  "Nébulisation & atomiseur de tout l'extérieur",
  "Plusieurs passages possibles",
  "Biocides professionnels, traitement choc",
  "Tous types de moustiques",
  "Efficace à 99 %, action rapide",
  "Déplacement inclus",
];

export const MARQUEE_TOWNS = [
  "Bordeaux", "Mérignac", "Pessac", "Talence", "Bègles", "Le Bouscat", "Bruges", "Blanquefort", "Parempuyre",
  "Arcachon", "La Teste-de-Buch", "Gujan-Mestras", "Andernos", "Lège-Cap-Ferret", "Libourne", "Saint-Émilion",
  "Lacanau", "Pauillac", "Soulac-sur-Mer", "Lesparre-Médoc", "Cenon", "Lormont", "Gradignan", "Villenave-d'Ornon",
];
